import { FC, useEffect, useState } from 'react';
import { BroadcastEditor } from '@/features/email-flows/broadcasts/components/BroadcastEditor';
import { useBroadcastEditorStore } from '@/features/email-flows/broadcasts/stores';
import { useBroadcastEditorData } from '@/features/email-flows/broadcasts/hooks/useBroadcastEditorData';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { MENUITEM_IDS } from '@/lib';
import { GenerateEmailTemplateWithStanley } from '@/features/email-flows/broadcasts/components/GenerateWithStanley';

const AddBroadcastPage: FC = () => {
    const resetStore = useBroadcastEditorStore(state => state.reset);
    const [templateGenerationStep, setTemplateGenerationStep] = useState(true);

    useBroadcastEditorData({ flowId: -1 });

    // Reset store and generation step on unmount
    useEffect(() => {
        return () => {
            resetStore();
            setTemplateGenerationStep(true);
        };
    }, [resetStore]);

    useBreadcrumbs([
        { title: 'My Email Flows', to: '/flows', id: MENUITEM_IDS.FLOWS, active: false },
        { title: 'Broadcasts', to: `/flows?tab=broadcasts`, id: 'broadcasts-tab', active: false },
        { title: 'Add Broadcast', to: `/flows/-1/broadcast/new`, id: 'add-broadcast', active: true },
    ]);

    return (
        <div className='mx-auto w-full max-w-screen-lg pb-6'>
            {templateGenerationStep ? (
                <div className='mx-auto mt-12 max-w-2xl md:mt-20'>
                    <GenerateEmailTemplateWithStanley onComplete={() => setTemplateGenerationStep(false)} />
                </div>
            ) : (
                <>
                    <div className='mb-6'>
                        <p className='text-heading-h2 mb-1'>New Email</p>
                    </div>
                    <BroadcastEditor flowId={-1} />
                </>
            )}
        </div>
    );
};

export default AddBroadcastPage;
